"use strict";const prepositionRegExp=/((^|[\s\xa0])[([(["'«"]?[a-zа-я1-90.]{1,3})[ ]/gi,nbspier=p=>{if(p){let e=0;for(;p.match(prepositionRegExp)&&(e++,p=p.replace(prepositionRegExp,"$1 "),!(3<e)););}return p};
/**
 * Добавляет неразрывный пробел после всех слов, длина которых меньше 4-х символов
 *
 * @param value - строка
 */module.exports=nbspier;
